import FormDynamicAutocomplete from './FormDynamicAutocomplete';

export default FormDynamicAutocomplete;
